const fetchAPI = async (url: string, initObj?: RequestInit) => {
  try {
    let baseURL = '/gateway/api';

    if (location && location.hostname !== 'www.atlassian.com') {
      baseURL = 'https://wac.stg.internal.atlassian.com' + baseURL;
    }
    const response = await fetch(baseURL + url, {
      credentials: 'include',
      ...initObj
    });

    return response;
  } catch (error) {
    throw new Error(
      (error instanceof Error ? error.message : JSON.stringify(error)) +
        ` ${url}`
    );
  }
};

export { fetchAPI };
